import React, { useEffect, useState } from "react";

export function RenderedFont({ identifiers }) {
  const [fontFace, setFontFace] = useState('');

  const fetchFontFace = async () => {
    try {
      const response = await fetch('/public/fonts/font_face?identifiers=' + identifiers, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      if (response.ok) {
        return await response.json();
      } else {
        throw new Error('Failed to fetch fonts');
      }
    } catch (error) {
      console.error(error);
      return '';
    }
  };

  useEffect(() => {
    fetchFontFace().then((response) => {
      setFontFace(response.fontFace);
    });
  }, []);

  return <style dangerouslySetInnerHTML={{ __html: fontFace }} />
}
